






























import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ForgotPasswordCompleted",
})
export default class ForgotPasswordCompleted extends Vue {
  public email = "";
  public isShow = false;

  public show(email) {
    this.email = email;
    this.isShow = true;
  }
}
